import { postP,get,getJ,put,deleteP,getExcel,uploadOther,uploadOtherSort,upload,postPackage,getPDF  } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    
    // 获取后台用户菜单权限
    // GetUserMenu(datas){
    //     return get('AUser/GetUserMenu',datas)
    // },
    // 创建后台用户
    CreateUser(datas){
        return postP('Admin/CreateUser',datas)
    },
    // 修改后台用户
    UpdateUser(datas){
        return postP('Admin/UpdateUser',datas)
    },
    // 查询后台用户
    QueryUsers(datas){
        return get('Admin/QuryUsers',datas)
    },

    

    // 获取角色列表
    QueryRole(datas){
        return get('Admin/QueryRole',datas)
    },
    // 更新角色
    UpdateRole(datas){
        return postP('Admin/UpdateRole',datas)
    },
    // 删除角色
    DeleteRole(datas){
        return deleteP('Admin/DeleteRole',datas)
    },
    // 创建后台用户角色
    CreateRole(datas){
        return postP('Admin/CreateRole',datas)
    },

    // 创建作业机构
    CreateMechanism(datas){
        return postP('Admin/CreateMechanism',datas)
    },
    // 修改作业机构
    UpdateMechanism(datas){
        return put('Admin/UpdateMechanism',datas)
    },
    // 删除作业机构
    deleteMechanism(datas){
        return deleteP('Admin/DeleteMechanism',datas)
    },
    // 作业机构列表
    QueryMechanism(datas){
        return get('Admin/QueryMechanism',datas)
    },
    // 作业机构详情
    QuryMechanismById(datas){
        return get('Admin/QuryMechanismById/'+datas)
    },

    //事业部列表
    QueryCauseList(datas){
        return get('Admin/QueryPagerAsync',datas)
    },
    //事业部详情
    QueryCauseById(datas){
        return get('Admin/QuryByIdAsync/'+datas)
    },
    // 修改事业部
    UpdateCause(datas){
        return put('Admin/UpdateAsync',datas)
    },
    // 创建事业部
    CreateCause(datas){
        return postP('Admin/CreateAsync',datas)
    },
    // 删除事业部
    DeleteCause(datas){
        return deleteP('Admin/DeleteAsync',datas)
    },

    
    

    //创建后台资源
    createResource(datas){
        return postP('Admin/CreateResource',datas)
    },
    //删除资源
    deleteResource(datas){
        return deleteP('Admin/DeleteResource',datas)
    },
    //获取所有菜单资源
    queryResource(datas){
        return get('Admin/QueryResource',datas)
    },
    //修改权限
    updateResource(datas){
        return postP('Admin/UpdateResource',datas)
    },
    

    // 创建角色菜单
    createPermission(datas){
        return postP('Admin/CreatePermission',datas)
    },
    // 修改角色菜单
    updatePermission(datas){
        return postP('Admin/UpdatePermission',datas)
    },
    // 根据角色查询权限
    queryRoleResource(datas){
        return get('Admin/queryPermission/'+datas)
    },
    


    // 创建合同
    createContract(datas){
        return postP('Contract/CreateAsync',datas)
    },
    // 修改合同
    updateContract(datas){
        return postP('Contract/UpdateAsync',datas)
    },
    // 删除合同
    deleteContract(datas){
        return deleteP('Contract/DeleteAsync',datas)
    },
    // 合同列表
    queryContractPager(datas){
        return get('Contract/QueryContractPager',datas)
    },
    // 查询合同
    queryContract(datas){
        return get('Contract/QueryContract/'+datas)
    },
    // 查询合同到期列表
    queryContractDqPager(datas){
        return get('Contract/QueryContractDqPager',datas)
    },
    
    // 查询权限列表菜单和操作权限
    queryPermissionMenuOperation(datas){
        return get('Admin/QueryPermissionMenuOperation/'+datas.resourceId)
    },
    
   


    // 通过角色Id查询角色名称
    queryRoleName(datas){
        return get('Admin/QueryRoleName',datas)
    },
    
    
    // 创建员工
    createUsers(datas){
        return postP('Users/CreateAsync',datas)
    },
    // 修改员工
    updateUsers(datas){
        return put('Users/UpdateAsync',datas)
    },
    // 删除员工
    deleteUsers(datas){
        return deleteP('Users/DeleteAsync',datas)
    },
    // 通过员工Id查询员工
    QueryUsersById(datas){
        return get('Users/QueryById/'+datas)
    },
    // 查询员工列表
    QueryUsersPager(datas){
        return get('Users/QueryPager',datas)
    },
    // 工作变更记录
    QueryUserJobTransferRecordById(datas){
        return get('Users/QueryUserJobTransferRecordById/'+datas)
    },
    // 员工证件
    QueryUserDocumentTypeById(datas){
        return get('Users/QueryUserDocumentTypeById/'+datas)
    },

    // 社保创建
    createSocialSecurity(datas){
        return postP('SocialSecurity/CreateAsync',datas)
    },
    // 社保修改
    updateSocialSecurity(datas){
        return put('SocialSecurity/UpdateAsync',datas)
    },
    // 社保删除
    deleteSocialSecurity(datas){
        return deleteP('SocialSecurity/DeleteAsync',datas)
    },
    // 社保详情
    querySocialSecurity(datas){
        return get('SocialSecurity/QueryById/'+datas)
    },
    // 社保列表
    queryPagerSocialSecurity(datas){
        return get('SocialSecurity/QueryPager',datas)
    },
   
    // 创建公积金
    createAccumulationFund(datas){
        return postP('AccumulationFund/CreateAsync',datas)
    },
    // 公积金修改
    updateAccumulationFund(datas){
        return put('AccumulationFund/UpdateAsync',datas)
    },
    // 公积金删除
    deleteAccumulationFund(datas){
        return deleteP('AccumulationFund/DeleteAsync',datas)
    },
    // 公积金详情
    queryAccumulationFund(datas){
        return get('AccumulationFund/QueryById/'+datas)
    },
    // 公积金列表
    queryPagerAccumulationFund(datas){
        return get('AccumulationFund/QueryPager',datas)
    },

    // 导入
    import(file,datas){
        return upload('Common/import/',file,datas)
    },
    // 导出数据
    export(datas){
        return getExcel('Common/Export',datas)
    },

    // 批量生成公积金
    batchGeneraAccumulationFund(datas){
        return get('AccumulationFund/batchGeneraAccumulationFund',datas)
    },
    // 批量生成社保
    batchGeneraSocialSecurity(datas){
        return get('SocialSecurity/BatchGeneraSocialSecurity',datas)
    },
    // 用印申请列表
    sealVerificationQueryPager(datas){
        return get('SealVerification/QueryPager/',datas)
    },
    // 用印申请编辑
    sealVerificationUpdateAsync(datas){
        return put('SealVerification/UpdateAsync',datas)
    },
    // 用印申请审核
    sealVerificationExamineAsync(datas){
        return put('SealVerification/ExamineAsync',datas)
    },
    // 用印申请添加
    sealVerificationAddAsync(datas){
        return postP('SealVerification/AddAsync',datas)
    },
    // 用印申请删除
    sealVerificationDeleteAsync(datas){
        return deleteP('SealVerification/DeleteAsync',datas)
    },


    // 车辆信息列表
    QueryCarPager(datas){
        return get('Car/QueryCarPager',datas)
    },
    // 通过车辆Id查询车辆信息
    QueryCarById(datas){
        return get('Car/QueryCarById/'+datas)
    },
    // 添加车辆
    AddCarAsync(datas){
        return postP('Car/AddCarAsync',datas)
    },
    // 编辑车辆
    UpdateCarAsync(datas){
        return put('Car/UpdateCarAsync',datas)
    },
    // 删除车辆
    DeleteCarAsync(datas){
        return deleteP('Car/DeleteCarAsync',datas)
    },
    // 保险信息列表
    queryCarInsurancePage(datas){
        return get('Car/queryCarInsurancePage',datas)
    },
    // 添加车辆保险信息
    addCarInsurance(datas){
        return postP('Car/AddCarInsuranceAsync',datas)
    },
    // 编辑车辆保险信息
    updateCarInsurance(datas){
        return put('Car/UpdateInsuranceAsync',datas)
    },
    // 删除车辆保险信息
    deleteCarInsurance(datas){
        return deleteP('Car/DeleteInsuranceAsync',datas)
    },

    // 车辆租赁信息列表
    queryCarLease(datas){
        return get('Car/QueryCarLeasePage',datas)
    },
    // 添加车辆租赁信息
    addCarLease(datas){
        return postP('Car/AddCarLeaseAsync',datas)
    },
    // 编辑车辆租赁信息
    updateCarLease(datas){
        return put('Car/UpdateLeaseAsync',datas)
    },
    // 删除车辆租赁信息
    deleteCarLease(datas){
        return deleteP('Car/DeleteLeaseAsync',datas)
    },


    // 车辆违章信息列表
    queryCarViolation(datas){
        return get('Car/QueryCarViolationPage',datas)
    },
    // 添加车辆违章信息
    addCarViolation(datas){
        return postP('Car/AddCarViolationAsync',datas)
    },
    // 编辑车辆违章信息
    updateCarViolation(datas){
        return put('Car/UpdateViolationAsync',datas)
    },
    // 删除车辆违章信息
    deleteCarViolation(datas){
        return deleteP('Car/DeleteViolationAsync',datas)
    },

    // 车辆费用信息列表
    queryCarCost(datas){
        return get('Car/QueryCarCostPage',datas)
    },
    queryCarCosts(datas){
        return get('Car/QueryCarCostPages',datas)
    },
    // 添加车辆费用信息
    addCarCost(datas){
        return postP('Car/AddCarCostAsync',datas)
    },
    // 编辑车辆费用信息
    updateCarCost(datas){
        return put('Car/UpdateCostAsync',datas)
    },
    // 删除车辆费用信息
    deleteCarCost(datas){
        return deleteP('Car/DeleteCostAsync',datas)
    },
    // 租赁到期查询
    queryCarZldq(datas){
        return get('Car/QueryCarZldq',datas)
    },
    // 保险到期查询
    queryCarBxdq(datas){
        return get('Car/QueryCarBxdq',datas)
    },
    // 奖惩列表
    queryUserRewardsDisciplinaryById(datas){
        return get('Users/QueryUserRewardsDisciplinaryById/'+datas)
    },
    queryUserRewardsDisciplinary(datas){
        return get('Users/QueryUserRewardsDisciplinary',datas)
    },
    uploadOther(file,params,name){
        return uploadOther('',file,params,name)
    },
    // uploadOtherSort(file,params){
    //     return uploadOtherSort('',file,params)
    // },
    // upload(file,params){
    //     return upload('Common/UploadFile',file,params)
    // },
}